import { put, select } from 'typed-redux-saga/macro';

import { getRoute } from 'Config';

import { verifyRouteSuccess } from 'Store/loading/actions';
import { navigate } from 'Store/routing/actions';
import { getIsUserLoggedIn } from 'Store/user/selectors';

export function* handleInitialRouting() {
  const isLoggedIn = yield* select(getIsUserLoggedIn);

  if (!isLoggedIn) {
    yield* put(
      navigate(
        getRoute('login', {
          pathConfig: { withPrefix: false },
        }),
        { replace: true }
      )
    );
  } else {
    yield* put(navigate(getRoute('recs'), { replace: true }));
  }
  yield* put(verifyRouteSuccess());
}
